import React from 'react';
import { Box } from '@mui/material';
import Markdown from '../components/widgets/Markdown';
import SkillLevel from './SkillLevel';
import YarnWeight from './YarnWeight';
import Measurements from './Measurements';
import Materials from './Materials';
import Needles from './Needles';
import Gauge from './Gauge';
import Abbreviations from './Abbreviations';
import OtherMaterials from './OtherMaterials';

const PatternPrintView = ({ pattern }) => (
  <Box>
    <div><strong>{pattern.name}</strong></div>
    {pattern.author && <div>by {pattern.author}</div>}
    <br/>
    {pattern.reference && <div><b>Reference for Stitch Patterns</b><br/>{pattern.reference}</div>}
    <br/>
    {pattern.description && <div><Markdown text={pattern.description} /><br/></div>}
    <YarnWeight value={pattern.yarnWeight} editMode={false} />
    <br/>
    <SkillLevel value={pattern.skillLevel} editMode={false} />
    <Measurements value={pattern.measurements} editMode={false} />
    <Materials value={pattern.materials} editMode={false} />
    <Needles value={pattern.needles} editMode={false} />
    <OtherMaterials value={pattern.otherMaterials} editMode={false} />

    <Gauge value={pattern.gauge} patternName={pattern.name} editMode={false} />

    <Abbreviations value={pattern.abbreviations} editMode={false} />

    {pattern.stitchPattern && <div><b>Stitch Patterns</b><br/><Markdown text={pattern.stitchPattern} /><br/></div>}
    {pattern.directions && <div><b>Swatch Directions</b><br/><Markdown text={pattern.directions} /><br/></div>}

    <Box sx={{ pageBreakBefore: 'always', mt: 4, pt: 2, borderTop: '1px solid #ddd' }}>
      <p style={{ fontStyle: 'italic' }}>
        Printed from StitchPortal - {new Date().toLocaleDateString()}
      </p>
    </Box>
  </Box>
);

export default PatternPrintView;
